/* Jokers 121026 v2 - quiet "Saving..." state for the Delivery Option flow.
   Only reacts to cart saves that follow a customer action inside the Delivery Option
   panel (tile, postcode, date). Swaps the Select and Checkout button labels to
   "Saving..." with a small spinner - no boxes, no layout shift.
   Display only: never blocks, delays or alters a request. Rollback = remove the loader line. */
(function () {
  if (window.__jkDelBusy) return;
  window.__jkDelBusy = true;

  var RX = /\/cart\/(change|update)(\.js)?(\?|$)/i;
  var PANEL = '#cart_drawer_shipping_option';
  var ARM_WINDOW = 12000; // saves count only within this long after a panel interaction
  var SHOW_DELAY = 1000;  // ignore saves that finish within a second
  var HIDE_DELAY = 700;   // bridge the gaps between ShipZip's chained saves
  var FAILSAFE = 20000;

  var armedUntil = 0, pending = 0, visible = false;
  var showT = null, hideT = null, failT = null;

  function armed() { return Date.now() < armedUntil; }
  function isWrite(method, url) {
    try { return String(method || 'GET').toUpperCase() === 'POST' && RX.test(String(url || '')); }
    catch (e) { return false; }
  }

  // Arm on any customer action inside the Delivery Option panel (except Select itself).
  function onPanelAction(e) {
    try {
      var t = e.target;
      if (!t || !t.closest || !t.closest(PANEL)) return;
      if (t.closest('button[aria-controls^="ShippingOption-"]')) return;
      armedUntil = Date.now() + ARM_WINDOW;
    } catch (err) {}
  }
  document.addEventListener('click', onPanelAction, true);
  document.addEventListener('change', onPanelAction, true);
  document.addEventListener('input', onPanelAction, true);

  /* ---------- UI: label swap only ---------- */
  function injectStyle() {
    if (document.getElementById('jk-busy-style')) return;
    var s = document.createElement('style');
    s.id = 'jk-busy-style';
    s.textContent =
      '.jk-saving{cursor:progress!important}' +
      '.jk-saving__spin{display:inline-block;vertical-align:-2px;width:13px;height:13px;margin-right:7px;' +
      'border-radius:50%;border:2px solid currentColor;border-right-color:transparent;' +
      'animation:jkSaveSpin .8s linear infinite}' +
      '@keyframes jkSaveSpin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){.jk-saving__spin{animation:none}}';
    document.head.appendChild(s);
  }

  function buttons() {
    var d = document.getElementById('CartDrawer');
    if (!d) return [];
    var out = [];
    var sel = d.querySelector(PANEL + ' button[aria-controls^="ShippingOption-"]');
    var co = d.querySelector('#cartDrawerForm [data-checkout], [data-checkout][form="cartDrawerForm"]');
    if (sel) out.push(sel);
    if (co) out.push(co);
    return out;
  }

  function label(btn) { return btn.querySelector('.btn-text') || btn; }

  function setSaving(on) {
    buttons().forEach(function (btn) {
      var el = label(btn);
      if (on) {
        if (btn.classList.contains('jk-saving')) return;
        // lock the width so the button never changes size
        var w = btn.getBoundingClientRect().width;
        if (w) btn.style.minWidth = w + 'px';
        btn.setAttribute('data-jk-label', el.innerHTML);
        el.innerHTML = '<span class="jk-saving__spin" aria-hidden="true"></span>Saving…';
        btn.classList.add('jk-saving');
        btn.setAttribute('aria-busy', 'true');
      } else {
        if (!btn.classList.contains('jk-saving')) return;
        var orig = btn.getAttribute('data-jk-label');
        if (orig !== null) el.innerHTML = orig;
        btn.removeAttribute('data-jk-label');
        btn.classList.remove('jk-saving');
        btn.removeAttribute('aria-busy');
        btn.style.minWidth = '';
      }
    });
  }

  function show() {
    showT = null;
    if (pending <= 0) return;
    injectStyle();
    setSaving(true);
    visible = true;
    clearTimeout(failT);
    failT = setTimeout(forceHide, FAILSAFE);
  }

  function hide() { hideT = null; if (pending <= 0) forceHide(); }

  function forceHide() {
    clearTimeout(failT); failT = null;
    setSaving(false);
    visible = false;
  }

  function begin() {
    pending++;
    if (hideT) { clearTimeout(hideT); hideT = null; }
    if (visible) { setSaving(true); return; } // re-apply if the drawer re-rendered
    if (!showT) showT = setTimeout(show, SHOW_DELAY);
  }

  function end() {
    pending = Math.max(0, pending - 1);
    if (pending > 0) return;
    if (showT) { clearTimeout(showT); showT = null; }
    if (visible && !hideT) hideT = setTimeout(hide, HIDE_DELAY);
  }

  /* ---------- request tracking (observe only) ---------- */
  try {
    var XHR = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (XHR && !XHR.__jkBusy) {
      XHR.__jkBusy = true;
      var origOpen = XHR.open, origSend = XHR.send;
      XHR.open = function (method, url) {
        try { this.__jkBusyWrite = isWrite(method, url); } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      XHR.send = function () {
        try {
          if (this.__jkBusyWrite && armed()) {
            var done = false;
            begin();
            this.addEventListener('loadend', function () { if (!done) { done = true; end(); } });
          }
        } catch (e) {}
        return origSend.apply(this, arguments);
      };
    }
  } catch (e) {}

  try {
    if (window.fetch && !window.fetch.__jkBusy) {
      var origFetch = window.fetch;
      var wrapped = function (input, init) {
        var track = false;
        try {
          var url = typeof input === 'string' ? input : (input && input.url);
          var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
          track = isWrite(method, url) && armed();
        } catch (e) {}
        var p = origFetch.apply(this, arguments);
        if (!track) return p;
        begin();
        return p.then(function (r) { end(); return r; }, function (err) { end(); throw err; });
      };
      wrapped.__jkBusy = true;
      window.fetch = wrapped;
    }
  } catch (e) {}
})();
